import { ensureDefined } from '@avantia/client-and-server-utilities';
import { HpImageButtonListControlProps } from '../../../engineClient/components/formControls/standard';
import { HpClientQuestionData } from '../../../engineClient/types';
import { HpClaimsCommonCustomData } from '../../../tools/utilities';
import { questionIds } from '../../../types/questionConstants';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { getPerilInclusionsWidgets, PerilCopyText } from '../../widgets/perilInclusionsWidget';

export type PerilInformationCustomControlProps = HpImageButtonListControlProps;

export interface PerilInformationCustomData {
  coverInclusionsTitle: string;
  coverExclusionsTitle: string;
  perilCopyText: { [key: string]: PerilCopyText };
  disclaimerText?: string;
}

export function PerilInformationCustomControl(props: PerilInformationCustomControlProps): JSX.Element | null {
  const { question, answers, pageProps } = props;
  const { policies } = pageProps as HpClaimsQuestionSetPageProps;
  const { data } = question;
  const { customData } = data as HpClientQuestionData;
  const perilInformationCustomData = ensureDefined(customData, 'customData') as unknown as PerilInformationCustomData;
  const commonCustomData = pageProps.commonCustomData as unknown as HpClaimsCommonCustomData;
  ensureDefined(commonCustomData, 'commonCustomData');
  const { coverInclusionsTitle, coverExclusionsTitle, disclaimerText } = perilInformationCustomData;
  const policyInstanceAnswer = answers[questionIds.policyInstance].customer;
  const policy = policies[policyInstanceAnswer as string];
  const { perilInformationWidget, perilHeader: header } = getPerilInclusionsWidgets({
    ...perilInformationCustomData,
    answers,
    policy,
    commonCustomData
  });

  return (
    <>
      <div className="hp-peril-information">
        {header}
        {perilInformationWidget.map((widget, index) => {
          const {
            coverTypeTitle: coverTypeHeader,
            whatsCovered: coverInclusions,
            whatsNotCovered: coverExclusions
          } = widget;
          return (
            <div key={index} className="hp-list-card">
              <h2>{coverTypeHeader}</h2>
              {createCoverDetailsCard(coverInclusions, coverInclusionsTitle)}
              {coverExclusions && createCoverDetailsCard(coverExclusions, coverExclusionsTitle)}
            </div>
          );
        })}
        {disclaimerText && <div className="hp-disclaimer">{disclaimerText}</div>}
      </div>
    </>
  );
}

function createCoverDetailsCard(coverInclusionsWidget: JSX.Element, title: string) {
  return (
    <>
      <div className="list-heading">{title}</div>
      {coverInclusionsWidget}
    </>
  );
}
